import { csx } from '@vtex/admin-ui'

export const wrapper = csx({
  alignItems: 'center',
  padding: '$space-2 $space-6',
  width: '100%',
  display: 'grid',
  'div:has(> input)': {
    width: '100%',
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: '20px 1fr',
    label: {
      width: '100%',
    },
  },

  '&:hover': {
    bg: '$form.neutralHover',
  },

  '&:not([aria-disabled="true"])': {
    cursor: 'pointer',
  },
})

export const insideWrapper = csx({
  padding: '$space-2 $space-12',
})

export const expandButton = csx({
  padding: '$space-0 !important',
  width: '24px',
  height: '24px !important',

  svg: {
    transition: 'transform .2s linear',
  },
})

export const rotateIcon = csx({
  svg: {
    transform: 'rotate(90deg)',
  },
})

export const checkbox = csx({
  overflow: 'hidden',
  height: '20px',
  width: '20px',

  '&:indeterminate::after': {
    position: 'relative',
  },
})
